import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("bl_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const org = localStorage.getItem("bl_org");
  if (org) cfg.headers["X-Org-Id"] = org;
  return cfg;
});

export const errMsg = (e) => {
  const d = e?.response?.data;
  if (d?.error?.message) return d.error.message;
  if (typeof d?.detail === "string") return d.detail;
  if (Array.isArray(d?.detail)) return d.detail.map((x) => x.msg).join("; ");
  return e?.message || "Something went wrong";
};

export const idem = (extra = {}) => ({ headers: { "Idempotency-Key": crypto.randomUUID(), ...extra } });

export const get = async (url, params) => (await api.get(url, { params })).data;

export async function downloadFile(url, filename, params) {
  const res = await api.get(url, { params, responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}
